import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    user: null,
    token: null,
    permissions: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
  },
  actions: {
    async postLogin({ commit }, { email, password }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API}/auth`,
          {
            email,
            password,
          }
        );

        const { user, token } = response.data;
        const permissionIdentifiers = user.permissions.map(p => p.identifier);

        commit('setUser', user);
        commit('setToken', token);
        commit('setPermissions', permissionIdentifiers);

        localStorage.setItem('userData', JSON.stringify(response.data));

        return response.data
      } catch (error) {
        throw error.response?.data || { error: "Erro ao fazer login." };
      }
    },
    initializeStore({ commit }) {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedData = JSON.parse(userData);
        commit('setUser', parsedData.user);
        commit('setToken', parsedData.token);
        const permissionIdentifiers = parsedData.user.permissions.map(p => p.identifier);
        commit('setPermissions', permissionIdentifiers);
      }
    }
  },
  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getPermissions: (state) => state.permissions,
  },
  modules: {},
});